import { UploadCardFile } from '@axa-asia/emma-stylesheet/lib/components/EmmaMolecules/EmmaUploadCard';
import { PKG_NAME } from '../store';
import { FeatureName } from '@/types/common';

export const UPDATE_FILES = `${PKG_NAME}/UPDATE_FILES`;
export const ADD_FILE_REQUEST = `${PKG_NAME}/ADD_FILE_REQUEST`;
export const ADD_FILE_SUCCESS = `${PKG_NAME}/ADD_FILE_SUCCESS`;
export const ADD_FILE_FAIL = `${PKG_NAME}/ADD_FILE_FAIL`;
export const DELETE_FILE = `${PKG_NAME}/DELETE_FILE`;
export const RETRY_UPLOAD = `${PKG_NAME}/RETRY_UPLOAD`;
export const CLEAN_ALL_ERROR_FILES = `${PKG_NAME}/CLEAN_ALL_ERROR_FILES`;

export const INCREMENT_UPLOAD_DOCUMENT_SEQUENCE = `${PKG_NAME}/INCREMENT_UPLOAD_DOCUMENT_SEQUENCE`;

export type AddFileRequestPayload = {
  file: UploadCardFile;
  featureName: FeatureName;
  submissionField: string;
  sequence: number;
};

export const addFileRequest = (payload: AddFileRequestPayload) => ({
  type: ADD_FILE_REQUEST as typeof ADD_FILE_REQUEST,
  payload,
});

export type AddFileSuccessPayload = {
  file: UploadCardFile;
  featureName: FeatureName;
  submissionField: string;
  documentTitle: string;
  sequence: number;
};
export const addFileSuccess = (payload: AddFileSuccessPayload) => ({
  type: ADD_FILE_SUCCESS as typeof ADD_FILE_SUCCESS,
  payload,
});

export type AddFileFailPayload = {
  featureName: FeatureName;
  submissionField: string;
  sequence: number;
  error?: string;
};
export const addFileFail = (payload: AddFileFailPayload) => ({
  type: ADD_FILE_FAIL as typeof ADD_FILE_FAIL,
  payload,
});

export type DeleteFilePayload = {
  featureName: FeatureName;
  submissionField: string;
  sequence: number;
};
export const deleteFile = (payload: DeleteFilePayload) => ({
  type: DELETE_FILE as typeof DELETE_FILE,
  payload,
});

export type CleanAllErrorFilesPayload = {
  featureName: FeatureName;
  submissionField: string;
};

export type RetryUploadPayload = {
  featureName: FeatureName;
  submissionField: string;
  originalSequence: number;
  newSequence: number;
};

export const retryUpload = (payload: RetryUploadPayload) => ({
  type: RETRY_UPLOAD as typeof RETRY_UPLOAD,
  payload,
});

export const cleanAllErrorFiles = (payload: CleanAllErrorFilesPayload) => ({
  type: CLEAN_ALL_ERROR_FILES as typeof CLEAN_ALL_ERROR_FILES,
  payload,
});

export const incrementUploadDocumentSequence = (
  featureName: FeatureName,
  submissionField: string,
) => ({
  type: INCREMENT_UPLOAD_DOCUMENT_SEQUENCE as typeof INCREMENT_UPLOAD_DOCUMENT_SEQUENCE,
  payload: { featureName, submissionField },
});

// Action Types for type-safe reducers
export type AddFileRequestAction = ReturnType<typeof addFileRequest>;
export type AddFileSuccessAction = ReturnType<typeof addFileSuccess>;
export type AddFileFailAction = ReturnType<typeof addFileFail>;
export type DeleteFileAction = ReturnType<typeof deleteFile>;
export type RetryUploadAction = ReturnType<typeof retryUpload>;
export type CleanAllErrorFilesAction = ReturnType<typeof cleanAllErrorFiles>;
export type IncrementUploadDocumentSequenceAction = ReturnType<typeof incrementUploadDocumentSequence>;

export type UploadDocumentAction =
  | AddFileRequestAction
  | AddFileSuccessAction
  | AddFileFailAction
  | DeleteFileAction
  | RetryUploadAction
  | CleanAllErrorFilesAction
  | IncrementUploadDocumentSequenceAction;
